module.exports = __webpack_public_path__ + "assets/imgs/news-page-img-11.v1.jpg";